import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getActiveSkiSuppliers() {
    return conduit.get('products/products/suppliers/ski/active');
  },
  getActiveSuppliersByProductTypeIds(payload) {
    return conduit.post('products/products/suppliers/active-by-product-type-ids',  payload);
  },
  /**
   * @returns {AxiosPromise}
   */
  getSkiSitesWithAreaAndCountry() {
    return conduit.get('products/products/sites/ski/with-area-and-country');
  },

  getSitesWithAreaAndCountryByProductTypeIds(payload) {
    return conduit.post('products/products/sites/by-product-type-ids', payload);
  },

  getPickupPlaces(payload) {
    return conduit.get(`ski/pickups/seasons/skipass/${payload}`);
  },

  updateSeasonPickupPlaces(payload) {
    return conduit.put(`ski/pickups/seasons/skipass/${payload.seasonId}`, payload.ids);
  },

  getSkiRentalPickupPlaces(payload) {
    return conduit.get(`ski/pickups/seasons/skirental/${payload}`);
  },

  updateSkiRentalPickupPlaces(payload) {
    return conduit.put(`ski/pickups/seasons/skirental/${payload.seasonId}`, payload.ids);
  },

  getSkiSchoolPickupPlaces(payload) {
    return conduit.get(`ski/pickups/seasons/skischool/${payload}`);
  },

  updateSkiSchoolPickupPlaces(payload) {
    return conduit.put(`ski/pickups/seasons/skischool/${payload.seasonId}`, payload.ids);
  },

  getXmlChannelsByType(type) {
    return conduit.get(`ski/xml-channels/type/${type}`);
  },
  getXmlProductsByType(type) {
    return conduit.get(`ski/xml-products/type/${type}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-service.js